const TOMADOR_DE_CARGA = 'TOMADOR_DE_CARGA'
const DADOR_DE_CARGA = 'DADOR_DE_CARGA'
const ADMIN = 'ADMIN'

export {
    TOMADOR_DE_CARGA,
    DADOR_DE_CARGA,
    ADMIN,
}